import { render, staticRenderFns } from "./DotacoesOrcamentarias.vue?vue&type=template&id=30aac698"
import script from "./DotacoesOrcamentarias.vue?vue&type=script&lang=js"
export * from "./DotacoesOrcamentarias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports